module.exports = __webpack_public_path__ + "static/media/gw5.18180cae.webp";